/** Matches @mui/material InitColorSchemeScript storage keys and logic. */
const MODE_STORAGE_KEY = 'mui-mode';
const COLOR_SCHEME_STORAGE_KEY = 'mui-color-scheme';
const COLOR_SCHEME_ATTR = 'data-mui-color-scheme';

/**
 * Resolves the color scheme synchronously before React paints.
 * Reads the attribute set by the blocking script in index.html first,
 * then falls back to localStorage (same rules as InitColorSchemeScript).
 */
export function getInitialColorScheme(): 'light' | 'dark' {
  if (typeof document !== 'undefined') {
    const applied = document.documentElement.getAttribute(COLOR_SCHEME_ATTR);
    if (applied === 'dark' || applied === 'light') {
      return applied;
    }
  }

  if (typeof localStorage === 'undefined') {
    return 'light';
  }

  try {
    const mode = localStorage.getItem(MODE_STORAGE_KEY) || 'system';
    const dark = localStorage.getItem(`${COLOR_SCHEME_STORAGE_KEY}-dark`) || 'dark';
    const light = localStorage.getItem(`${COLOR_SCHEME_STORAGE_KEY}-light`) || 'light';

    if (mode === 'dark') {
      return dark === 'dark' ? 'dark' : 'light';
    }
    if (mode === 'light') {
      return light === 'light' ? 'light' : 'dark';
    }
    if (mode === 'system' && typeof window.matchMedia === 'function') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
  } catch {
    // localStorage unavailable (private browsing, etc.)
  }

  return 'light';
}
